// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"436":"3614757e","2506":"3614757e","2553":"3614757e","3309":"3614757e","6286":"3614757e","8736":"3614757e"}[chunkId] + ".chunk.css";
};